import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isEmpty, sortBy } from 'lodash'

import { getDevices } from '../../../core/services/environmentService'
import { getAllTeams } from '../../../../components/data/dataServices'

import { ENV_ACTIONS } from '../../../../reducers/environmentReducer'
import { logErrorMessage } from 'utils/functions/helpers'

export function useTeams() {
	const { environment } = useSelector((state) => state)
	const dispatch = useDispatch()
	const [loadingTeams, setLoadingTeams] = useState(false)
	const [loadingDevices, setLoadingDevices] = useState(false)

	useEffect(() => {
		if (!environment.refresh) return
		setLoadingDevices(true)
		dispatch({
			type: ENV_ACTIONS.CLEAR_DEVICES,
		})
		getDevices(environment.apiToken)
			.then((data) => {
				const devices = data.data
				dispatch({
					type: ENV_ACTIONS.GET_DEVICES,
					payload: devices,
				})
				setLoadingDevices(false)
				initiateLoadAllTeams(devices)
			})
			.catch((err) => {
				setLoadingDevices(false)
				console.log(err)
			})
			.finally(() => {
				dispatch({
					type: ENV_ACTIONS.REFRESH,
					payload: false,
				})
			})
	}, [environment.refresh])

	//Doesn't need to load devices since we load devices from environment load
	const initiateLoadAllTeams = (devices) => {
		setLoadingTeams(true)
		loadAllTeams()
			.then((res) => {
				let teams = sortBy(res.data, (team) => team.name.toLowerCase())
				if (devices?.length) {
					teams = teams.map((team) => {
						let teamDevices = devices.filter((device) => device.teamKey === team.key)
						teamDevices = sortBy(teamDevices, (team) => team.name.toLowerCase())
						return { ...team, devices: teamDevices }
					})
				}

				dispatch({
					type: ENV_ACTIONS.GET_TEAMS,
					payload: teams,
				})
				setLoadingTeams(false)
			})
			.catch((err) => {
				logErrorMessage(err)
			})
	}

	const loadAllTeams = async () => {
		let promise = await getAllTeams(environment.apiToken)
		return promise
	}

	useEffect(() => {
		if (isEmpty(environment?.teams)) {
			setLoadingDevices(true)
			getDevices(environment.apiToken)
				.then((data) => {
					const devices = data.data
					dispatch({
						type: ENV_ACTIONS.GET_DEVICES,
						payload: devices,
					})
					setLoadingDevices(false)
					initiateLoadAllTeams(devices)
				})
				.catch((err) => {
					setLoadingDevices(false)
					console.log(err)
				})
				.finally(() => {
					dispatch({
						type: ENV_ACTIONS.REFRESH,
						payload: false,
					})
				})
		}
	}, [])

	return {
		loadingDevices,
		loadingTeams,
	}
}
